<template>
	<div id="app" class="bg-c-fff">
		<div v-show="loading" class="w-100 h-100 bg-c-f8f8f8"></div>
		<div v-show="!loading" :style="style" :class="name == 'Inquire' || name == 'InquireDetail' ? 'InquireHome' : 'home'" >
			<header v-if="name != 'Inquire' && name != 'InquireDetail'" class="bg-c-fff">
				<!-- 导航菜单 -->
				<div class="ls-flex-center p-tb-50">
					<div class="max-width ls-flex ls-al-center ls-jc-space-between">
						<div class="ls-flex">
							
							<router-link :to="`/`" class="ls-flex-flex ls-flex ls-al-center">
								<div class="logo_img">
									<img :src="logo_img" style="width: 307px;height: 77px;" alt="" srcset="" />
								</div>
								<div class="logo_text m-l-40">
									<div class="fs-20 f-D3312C">实时报道  深度客观</div>
									<div class="fs-16 f-666">国内主流新闻资讯媒体</div>
								</div>
							</router-link>
						</div>
						<div class="sousuo ls-flex ls-al-center">
							<div style="width: 450px;" class="b-r-10 b-c-ccc p-20 ls-flex">
								
								<router-link :to="`/Search`" class="ls-flex-flex ls-flex ls-al-center ls-jc-space-between">
									<div class="fs-18 f-999">搜索</div>
									<img :src="sousuo" style="width: 20px;height: 22px;" alt="" srcset="" />
								</router-link>
							</div>
							<div @click="open({link:readnews_url})" class="ls-flex-col-center m-l-40 cursor-pointer">
								<img :src="baozhi" style="width: 30px;height: 34px;" alt="" srcset="" />
								<div class="fs-18 f-333">读报</div>
							</div>
						</div>
					</div>
				</div>
				<div class="daohang">
					<div class="bg-c-0146AE ">
						<div class="ls-flex-center">
							<div class="max-width ls-flex p-tb-10">
								<div class="ls-flex-flex cursor-pointer ls-flex" @mousemove="childrenSelect(item,index)" v-for="(item,index) in routes" :key="index">
									<div class="fs-20 f-fff f-bold">{{item.name || ''}}</div>
									<div class="ls-flex ls-al-center m-l-10">
										<img :src="sanjiao" :class="routeIndex == index ? 'sanjiao-xia' : 'sanjiao-shang'" style="width: 16px;height: 16px;" alt="" srcset="" />
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="erji">
						<div class="ls-flex-center">
							<div class="max-width ls-flex p-tb-10">
								<div class="m-r-50 cursor-pointer" v-for="(item,index) in routes[routeIndex].subLevel" :key="index">
									<router-link :to="`/HomeEdit?typeId=${item.id}`" class="ls-flex-flex">
										<div class="fs-20 f-333">{{item.name || ''}}</div>
									</router-link>
								</div>
							</div>
						</div>
					</div>
				</div>
				
			</header>

			<main :class="name == 'Inquire' || name == 'InquireDetail' ? 'InquireMain' : 'main'">
				<router-view></router-view>
			</main>

			<footer v-if="name != 'Inquire' && name != 'InquireDetail'" class="p-t-30 p-b-40" style="background-color: #0146AE; overflow: hidden;">
				<div class="ls-flex-col-center f-fff">
					<!-- <div class="ls-flex fs-14 f-fff m-b-20">
						关于我们  |  外宣服务和广告服务  |  联系我们  |  网站公告  |  声明  |  本网律师  |    
						<router-link :to="`/Inquire`" class="ls-flex-flex">
							<div class="fs-14 f-fff ">人员查询</div>
						</router-link>
						|  邮箱
					</div> -->
					<div class="ls-flex fs-14 f-fff m-b-20">
						<div class="ls-flex ls-al-center" v-for="(item,index) in downJumpList" :key="index">
							<router-link v-if="item.jump_url" :to="item.jump_url" >
								<div class="fs-14 f-fff ">{{index < downJumpList.length - 1 ? item.name + '&nbsp;|&nbsp;' : item.name}}</div>
							</router-link>
							<div v-else class="fs-14 f-fff ">{{index < downJumpList.length - 1 ? item.name + ' | ' : item.name}}</div>
						</div>
						
					</div>
					<div class="m-b-20" v-html="footerText1"></div>
					<div class="m-b-20" v-html="footerText2"></div>
					<div class="m-b-20" v-html="footerText3"></div>
					<div class="m-b-20" v-html="footerText4"></div>
					<div class="m-b-20" v-html="footerText5"></div>
					<div class="m-b-20" v-html="footerText6"></div>
					<div class="" v-html="footerText7"></div>
					<div class="p-t-40 ls-flex ls-flex-rw ls-jc-center" style="width: 1230px;">
						<div @click="open({link:item.outlink})" class="m-b-20 cursor-pointer" :class="index != footerImg.length % 5 ? 'm-l-20' : ''" v-for="(item,index) in footerImg">
							<img :src="item.image" style="height: 60px;width: auto;" alt="" srcset="" />
						</div>
					</div>
				</div>
			</footer>
		</div>
	</div>
</template>

<script>
import { getIndexText, getNewsType, getIndexNewsList, getBottomImage, getConfig, getDownJumpList} from "@/api/api.js";
export default {
	data() {
		return {
			lists: [],
			routes: [
				{
					subLevel:[]
				}
			],
			newDataList:[],
			routeIndex:0,
			name:'',
			logo_img: require('@/assets/image/logo_img.png'),
			baozhi: require('@/assets/image/baozhi.png'),
			sousuo: require('@/assets/image/sousuo.png'),
			sanjiao: require('@/assets/image/sanjiao.png'),
			footerText1:'',
			footerText2:'',
			footerText3:'',
			footerText4:'',
			footerText5:'',
			footerText6:'',
			footerText7:'',
			footerImg:[],
			style:{},
			readnews_url:'',
			loading:true,
			downJumpList:[]
		};
	},

	created() {
		let _self = this;
		_self.getData();
		console.log(window.screen.availWidth,'window.innerWidth');
		if (window.screen.availWidth < 1440) {
			let num = window.screen.availWidth / 1440;
			_self.style = {
				width: '1440px',
				position: 'absolute',
				top:'0',
				left:'50%',
				transformOrigin:'top left',
				transform: 'scale(' + num + ') translate(-50%,0)'
			}
		}
		setTimeout(()=>{
			_self.loading = false;
		},1500)
	},
	// 监听路由变化
	watch: {
		$route: {
			handler: function (val, oldVal) {
				console.log(val,'valvalvalvalval');
				this.name = val.name;
				this.toTop();
				if (val.query.typeId) {
					if (val.query.typeId == 999999999) {
						this.$store.state.typeName = '搜索';
					} else{
						this.newDataList.forEach((item,index) => {
							if (item.id == val.query.typeId) {
								// console.log(item);
								this.$store.state.typeName = item.name;
							}
						})
						this.routes[this.routeIndex].subLevel.forEach((item,index) => {
							if (item.id == val.query.typeId) {
								this.$store.state.typeName = item.name;
							}
						})
					}
				}
			},
			deep: true,
		}
	},
	methods: {
		// 返回顶部
		toTop() {
			document.documentElement.scrollTop = 0;
		},
		// 跳转首页
		toHome() {
			this.$router.push("/");
			this.toTop();
		},
		// 获取数据
		getData() {
			let _self = this;
			getIndexText({type:'2'}).then((res) => {
				_self.footerText1 = res.data.content;
			});
			getIndexText({type:'3'}).then((res) => {
				_self.footerText2 = res.data.content;
			});
			getIndexText({type:'4'}).then((res) => {
				_self.footerText3 = res.data.content;
			});
			getIndexText({type:'5'}).then((res) => {
				_self.footerText4 = res.data.content;
			});
			getIndexText({type:'6'}).then((res) => {
				_self.footerText5 = res.data.content;
			});
			getIndexText({type:'7'}).then((res) => {
				_self.footerText6 = res.data.content;
			});
			getIndexText({type:'8'}).then((res) => {
				_self.footerText7 = res.data.content;
			});
			getNewsType().then((res) => {
				_self.routes = res.data;
				let routes = [];
				res.data.forEach(item => {
					if (item.subLevel.length > 0) {
						item.subLevel.forEach(im => {
							if(im.pinyin){
								let obj = {
									path: im.pinyin ? '/' + im.pinyin + '/HomeDetail' : '/HomeDetail',
									name: im.pinyin ? '/' + im.pinyin + '/HomeDetail' : '/HomeDetail',
									meta: { china:'详情',en:'list' },
									component: () => import('@/views/HomeDetail.vue'),
								}
								routes.push(obj);
							}
						})
					}
				})
				_self.$store.state.routes = routes;
			});
			getIndexNewsList().then((res) => {
				if (res && res.data) {
					_self.newDataList = res.data;
				}
			});
			getBottomImage().then((res) => {
				if (res && res.data) {
					_self.footerImg = res.data;
				}
			});
			getConfig().then((res) => {
				if (res && res.data) {
					_self.readnews_url = res.data.readnews_url;
				}
			});
			getDownJumpList().then((res) => {
				if (res && res.data) {
					_self.downJumpList = res.data;
				}
			});
			
		},
		open(im){
			let _self = this;
			_self.$publis.open(im.link);
		},
		// 搜索
		search() {
			this.$router.push(`/search?value=${this.value}`);
		},
		childrenSelect(im,ix){
			this.routeIndex = ix;
			this.$store.state.routeIndex = ix;
			
		}
	},
	mounted() {
		
	},
};
</script>

<style lang="scss">
	@font-face {
		font-family: 'myfont';
		src: url('./assets/fonts/MSYH.TTF');
	}
	@font-face {
		font-family: 'myfontbd';
		src: url('./assets/fonts/MSYHBD.TTF');
	}
a {
  text-decoration: none;
  // color: #ffffff;
}

a:link {
  color: #fff;
}

* {
	padding: 0;
	margin: 0;
	// font-size: 14px;
	font-family: 'myfont' , sans-serif;
	box-sizing: border-box;
}

html,
body {
	width: 100%;
	height: auto;
	scroll-behavior: smooth;
	overflow: visible;
	@media screen and (max-width: 1200px) {
		overflow: visible !important;
		// font-size: 12px !important;
	}
}
body {
    transition: transform 0.5s ease-in-out;
  }
@media screen and (max-width: 1440px) {
	html,
	body {
		width: 100%;
	}
	#app{
		position: relative;
		width: 1440px;
	}
}
#app {
	width: 100vw;
	height: 100vh;
	.erji{
		display: none;
	}
	.daohang:hover .erji{
		display: block !important;
	}
	.sanjiao-xia{
		transition: all 0.3s 0s;
		transform: rotateZ(90deg);
	}
	.sanjiao-shang{
		transition: all 0.3s 0s;
		transform: rotateZ(-90deg);
	}
	
	.description{
		color: #333;
	}
	.title{
		color: #000;
	}
	.dataText{
		cursor: pointer;
	}
	.dataText:hover .title{
		color: #0146AE !important;
	}
	.dataText:hover .description{
		color: #0146AE !important;
	}
	.image{
		transition: all 0.3s 0s;
	}
	.dataText:hover .image{
		transform: scale(1.2);
	}
	.dataText:hover .f-999{
		color: #0146AE !important;
	}
	.dataText:hover .f-cc0000{
		color: #0146AE !important;
	}
	
	.w-max-content{
		width: max-content;
	}
	.ls-flex{
		display: flex;
	}
	.ls-flex-col{
		display: flex;
		flex-direction: column;
	}
	.ls-flex-center{
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.ls-flex-col-center{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	.ls-al-center{
		align-items: center;
	}
	.ls-al-end{
		align-items: flex-end;
	}
	.ls-jc-center{
		justify-content: center;
	}
	.ls-jc-space-between{
		justify-content: space-between;
	}
	.ls-jc-space-evenly{
		justify-content: space-evenly;
	}
	.ls-flex-flex{
		flex: 1;
	}
	.ls-flex-rw{
		flex-flow: row wrap;
	}
	.f-000{
		color: #000 !important;
	}
	.f-fff{
		color: #fff !important;
	}
	.f-333{
		color: #333 !important;
	}
	.f-666{
		color: #666 !important;
	}
	.f-999{
		color: #999;
	}
	.f-D3312C{
		color: #D3312C !important;
	}
	.f-cc0000{
		color: #cc0000;
	}
	.f-0046ae{
		color: #0046ae !important;
	}
	
	.ta-center{
		text-align: center;
	}
	.ta-justify{
		text-align: justify;
	}
	
	.bg-c-fff{
		background-color: #fff;
	}
	.bg-c-f8f8f8{
		background-color: #f8f8f8;
	}
	.bg-c-0146AE{
		background-color: #0146AE;
	}
	.bg-c-f6f6f6{
		background-color: #f6f6f6;
	}
	
	.b-c-ccc{
		border: 1px solid #CCCCCC;
	}
	.b-c-E0DFDD{
		border: 1px solid #E0DFDD;
	}
	.f-bold{
		font-weight: bold;
		font-family: 'myfontbd' , sans-serif;
	}
	/* // 字体 */
	.fs-14{
		font-size: 0.875rem !important;
		
	}
	.fs-16{
		font-size: 1rem !important;
	}
	.fs-18{
		font-size: 1.125rem !important;
	}
	.fs-20{
		font-size: 1.25rem !important;
	}
	.fs-22{
		font-size: 1.375rem !important;
	}
	.fs-24{
		font-size: 1.5rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 0.875rem !important;
		}
	}
	.fs-28{
		font-size: 1.75rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.125rem !important;
		}
	}
	.fs-26{
		font-size: 1.625rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1rem !important;
		}
	}
	.fs-30{
		font-size: 1.875rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.25rem !important;
		}
	}
	.fs-32{
		font-size: 2rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.375rem !important;
		}
	}
	.fs-34{
		font-size: 2.125rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.5rem !important;
		}
	}
	.fs-36{
		font-size: 2.25rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.625rem !important;
		}
	}
	.fs-38{
		font-size: 2.375rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.75rem !important;
		}
	}
	.fs-40{
		font-size: 2.5rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 1.875rem !important;
		}
	}
	.fs-42{
		font-size: 2.625rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 2rem !important;
		}
	}
	.fs-46{
		font-size: 2.875rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 2.25rem !important;
		}
	}
	.fs-60{
		font-size: 3.75rem !important;
		@media screen and (max-width: 1200px) {
			font-size: 3.125rem !important;
		}
	}
	.l-h-24{
		line-height: 1.5rem;
	}
	.l-h-28{
		line-height: 1.75rem;
	}
	.l-h-30{
		line-height: 1.875rem;
	}
	.l-h-34{
		line-height: 2.125rem;
	}
	.l-h-36{
		line-height: 2.25rem;
	}
	.l-h-38{
		line-height: 2.375rem;
	}
	.l-h-40{
		line-height: 2.5rem;
	}
	.f-family{
		// font-family: Microsoft YaHei;
		font-style: italic;
	}
	.f-family-myfont{
		font-size: 22px;
		font-family: 'myfont' , sans-serif;
	}
	/* // margin上下 */
	.m-tb-10{
		margin: 0.625rem 0;
	}
	.m-tb-20{
		margin: 1.25rem 0;
	}
	.m-tb-30{
		margin: 1.875rem 0;
	}
	.m-tb-40{
		margin: 2.5rem 0;
	}
	.m-tb-50{
		margin: 3.125rem 0;
	}
	/* // margin左右 */
	.m-lr-10{
		margin: 0 0.625rem;
	}
	.m-lr-20{
		margin: 0 1.25rem;
	}
	.m-lr-30{
		margin: 0 1.875rem;
	}
	.m-lr-40{
		margin: 0 2.5rem;
	}
	.m-lr-50{
		margin: 0 3.125rem;
	}
	/* // padding上下 */
	.p-tb-10{
		padding: 0.625rem 0;
	}
	.p-tb-15{
		padding: 0.9375rem 0;
	}
	.p-tb-20{
		padding: 1.25rem 0;
	}
	.p-tb-30{
		padding: 1.875rem 0;
		
	}
	.p-tb-40{
		padding: 2.5rem 0;
		
	}
	.p-tb-50{
		padding: 3.125rem 0;
	}
	/* // padding左右 */
	.p-lr-10{
		padding: 0 0.625rem;
	}
	.p-lr-15{
		padding: 0 0.9375rem;
	}
	.p-lr-20{
		padding: 0 1.25rem;
	}
	.p-lr-30{
		padding: 0 1.875rem;
	}
	.p-lr-40{
		padding: 0 2.5rem;
	}
	.p-lr-50{
		padding: 0 3.125rem;
	}
	/* // margin-left */
	.m-l-10{
		margin-left: 0.625rem;
	}
	.m-l-15{
		margin-left: 0.9375rem;
	}
	.m-l-20{
		margin-left: 1.25rem;
	}
	.m-l-30{
		margin-left: 1.875rem;
	}
	.m-l-40{
		margin-left: 2.5rem;
	}
	.m-l-50{
		margin-left: 3.125rem;
	}
	.m-l-80{
		margin-left: 5rem;
	}
	/* // margin-right */
	.m-r-10{
		margin-right: 0.625rem;
	}
	.m-r-15{
		margin-right: 0.9375rem;
	}
	.m-r-20{
		margin-right: 1.25rem;
	}
	.m-r-25{
		margin-right: 1.5625rem;
	}
	.m-r-30{
		margin-right: 1.875rem;
	}
	.m-r-40{
		margin-right: 2.5rem;
	}
	.m-r-50{
		margin-right: 3.125rem;
	}
	/* // margin-top */
	.m-t-10{
		margin-top: 0.625rem;
	}
	.m-t-15{
		margin-top: 0.9375rem;
	}
	.m-t-20{
		margin-top: 1.25rem;
	}
	.m-t-25{
		margin-top: 1.5625rem;
	}
	.m-t-30{
		margin-top: 1.875rem;
	}
	.m-t-35{
		margin-top: 35px;
	}
	.m-t-40{
		margin-top: 2.5rem;
	}
	.m-t-50{
		margin-top: 3.125rem;
	}
	/* // margin-top */
	.m-b-10{
		margin-bottom: 0.625rem;
	}
	.m-b-15{
		margin-bottom: 0.9375rem;
	}
	.m-b-20{
		margin-bottom: 1.25rem;
	}
	.m-b-25{
		margin-bottom: 1.5625rem;
	}
	.m-b-30{
		margin-bottom: 1.875rem;
	}
	.m-b-40{
		margin-bottom: 2.5rem;
	}
	.m-b-50{
		margin-bottom: 3.125rem;
	}
	/* // padding-left */
	.p-l-10{
		padding-left: 0.625rem;
	}
	.p-l-20{
		padding-left: 1.25rem;
	}
	.p-l-30{
		padding-left: 1.875rem;
	}
	.p-l-40{
		padding-left: 2.5rem;
	}
	.p-l-60{
		padding-left: 3.75rem;
	}
	/* // padding-right */
	.p-r-10{
		padding-right: 0.625rem;
	}
	.p-r-20{
		padding-right: 1.25rem;
	}
	.p-r-30{
		padding-right: 1.875rem;
	}
	.p-r-40{
		padding-right: 2.5rem;
	}
	/* // padding-top */
	.p-t-10{
		padding-top: 0.625rem;
	}
	.p-t-20{
		padding-top: 1.25rem;
	}
	.p-t-30{
		padding-top: 1.875rem;
	}
	.p-t-40{
		padding-top: 2.5rem;
	}
	/* // padding-bottom */
	.p-b-10{
		padding-bottom: 0.625rem;
	}
	.p-b-20{
		padding-bottom: 1.25rem;
	}
	.p-b-30{
		padding-bottom: 1.875rem;
	}
	.p-b-40{
		padding-bottom: 2.5rem;
	}
	/* // padding */
	.p-10{
		padding: 0.625rem;
	}
	.p-15{
		padding: 0.9375rem;
	}
	.p-20{
		padding: 1.25rem;
	}
	.p-30{
		padding: 1.875rem;
		
	}
	.p-40{
		padding: 2.5rem;
	}
	.b-r-10{
		border-radius: 0.625rem;
	}
	.b-r-20{
		border-radius: 1.25rem;
	}
	.b-r-30{
		border-radius: 1.875rem;
	}
	.b-r-50{
		border-radius: 50%;
	}
	.parting-line-CCD4FF{
		height: 1px;
		background-color: #CCD4FF;
	}
	.parting-line-f5f5f5{
		height: 1px;
		background-color: #f5f5f5;
	}
	.parting-line-B8DEFF{
		width: 1px;
		height: 135px;
		background-color: #B8DEFF;
	}
	.text-ellipsis-1{
		overflow: hidden;
		-webkit-line-clamp: 1;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
	.text-ellipsis-2{
		overflow: hidden;
		-webkit-line-clamp: 2;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
	.text-ellipsis-3{
		overflow: hidden;
		-webkit-line-clamp: 3;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-box-orient: vertical;
	}
	.ov-hidden{
		overflow: hidden;
	}
	.max-width{
		width: 1440px;
		@media screen and (max-width: 1440px) {
			padding-left: 30px;
			padding-right: 30px;
		}
	}
	.w-100{
		width: 100%;
	}
	.w-max-content{
		width: max-content;
	}
	.h-100{
		height: 100%;
	}
	.h-0{
		height: 0;
	}
	.cursor-pointer{
		cursor: pointer;
	}
	.bg-i-center{
		background-repeat: no-repeat;
		background-position: center;
	}
	.bg-i-center-cover{
		background-repeat: no-repeat;
		background-size: cover;
		background-position: center;
	}
}

.main {
	height: auto;
	width: 100%;
	@media screen and (max-width: 1440px) {
		width: 1440px !important;
		padding: 240px 30px 0 30px;
	}
	@media screen and (max-width: 1200px) {
		width: 1440px !important;
		padding: 40px 30px 0 30px;
	}
}
.InquireMain{
	height: 100% !important;
	width: 100%;
}
.home {
	// transform-origin: 0 0;
	// position: absolute;
	// left: 50%;
	// top: 0;
	// transition: .3s;
}
.InquireHome{
	width: 100%;
	height: 100%;
	// transform-origin: 0 0;
	// position: absolute;
	// left: 50%;
	// top: 0;
	// transition: .3s;
}
header {
	width: 100%;
	z-index: 999999;
	@media screen and (max-width: 1400px) {
		width: 1440px !important;
		z-index: 200000000;
	}
	box-shadow: 0px 5px 20px 0px rgba(0, 0, 0, 0.04);
}

footer {
  // margin-top: 6.5625rem;
	@media screen and (max-width: 1400px) {
		width: 1440px !important;
	}
}
// 进度条颜色
// #nprogress .bar {
//   background: blue !important; //这里可以随便写颜色
// }
</style>
